var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
    color: '#A0A0A0',
    onClick: function () { },
};
var SideMenuIcon = function SideMenuIcon(props) {
    var color = props.color, onClick = props.onClick;
    return (_jsxs("svg", __assign({ width: "5", height: "23", viewBox: "0 0 5 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "side-menu-icon", onClick: onClick }, { children: [_jsx("circle", { cx: "2.5", cy: "2.5", r: "2.5", fill: color }), _jsx("circle", { cx: "2.5", cy: "11.5", r: "2.5", fill: color }), _jsx("circle", { cx: "2.5", cy: "20.5", r: "2.5", fill: color })] })));
};
SideMenuIcon.defaultProps = defaultProps;
export default SideMenuIcon;
